import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

import { IMarketingDocument } from 'src/app/core/models/masters/marketing-document.model';
import { GenericListView } from 'src/app/infrastructure/infrastructure-services/generics/genericlistview/generic-list-view';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { WrapperStandardRequest } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-copy-from-popup',
  templateUrl: './item-component.component.html',
  styleUrls: ['./item-component.component.css']
})
export class ItemComponent extends GenericListView<IMarketingDocument> implements OnInit {
  local_data: any[] = [];
  documentEntry: string = ""
  documentName: string = ""

  pageNumber = 1;
  hasMoreLines = true;
  isLoadingMoreLines = false;
  url: string = '';
  requestData: any;
  docEntryFilter: any;
  repo: GenericService<IMarketingDocument>;

  constructor(agenericRepository: GenericService<IMarketingDocument>, router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>,
    private ngxUiLoaderService: NgxUiLoaderService) {
    super(agenericRepository, router)
    this.repo = agenericRepository;

    if (data && data.lines) {
      this.documentName = data.name;
      if (data.url) {
        this.local_data = [];
      } else {
        this.local_data = data.lines.map((i: any) => { return { ...i, selected: false }; });
      }
      this.url = data.url;
      this.requestData = data.requestData;

      if (this.requestData && this.requestData.RequestData) {
        this.docEntryFilter = this.requestData.RequestData.find((f: any) => f.Key === 'DocEntry');
      }
    } else {
      this.local_data = data ? data.map((i: any) => { return { ...i, selected: false }; }) : [];
    }
    // this.setListViewDataSourceURL = this.local_data.endPoint;
    this.setDisplayedColumnsNamesList = ['select', '#', 'baseDoc', 'lineNum', 'itemNo', 'itemDesc', 'qty', 'openQuanity'];
    console.log('this.local_data', data)
    // this.getRequestData.RequestData = [
    //   {
    //     "Key": "cardCode",
    //     "Value": this.local_data.docEntry,
    //     "OperatorType": "startswith"
    //   },
    //   {
    //     "Key": "cardCode",
    //     "Value": "",
    //     "OperatorType": "endswith"
    //   },
    //   {
    //     "Key": "documentStatus",
    //     "Value": "O",
    //     "OperatorType": "contains"
    //   }
    // ]

    // this.getRequestData.SortColumn = "docEntry";
    // this.PopulateListView();
  }

  ngOnInit() {
    if (this.url) {
      this.pageNumber = 0;
      this.loadMoreDocumentLines();
    }
  }

  onSelectionChange(row: any, event: MatCheckboxChange) {
    row.selected = event.checked;
  }

  onSelectAllChange(event: MatCheckboxChange) {
    const isChecked = event.checked;
    if (this.local_data && Array.isArray(this.local_data)) {
      this.local_data.forEach((row: any) => {
        if (row.lineStatus !== 'C') {
          row.selected = isChecked;
        }
      });
    }
  }

  isAllSelected(): boolean {
    if (!this.local_data || !Array.isArray(this.local_data) || this.local_data.length === 0) return false;
    const availableRows = this.local_data.filter((row: any) => row.lineStatus !== 'C');
    if (availableRows.length === 0) return false;
    return availableRows.every((row: any) => row.selected);
  }

  isSomeSelected(): boolean {
    if (!this.local_data || !Array.isArray(this.local_data) || this.local_data.length === 0) return false;
    const availableRows = this.local_data.filter((row: any) => row.lineStatus !== 'C');
    return availableRows.some((row: any) => row.selected) && !this.isAllSelected();
  }
  onClose() {
    this.ngxUiLoaderService.start();
    this.dialogRef.close({ event: true, value: this.local_data.filter((i: any) => { return i.selected == true }) });
  }

  async onTableScroll(event: any) {
    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 10) {
      if (!this.isLoadingMoreLines && this.hasMoreLines) {
        this.loadMoreDocumentLines();
      }
    }
  }

  async loadMoreDocumentLines() {
    if (!this.hasMoreLines || this.isLoadingMoreLines || !this.url) return;

    this.isLoadingMoreLines = true;
    this.pageNumber++;

    const request = new WrapperStandardRequest<any>();
    request.RequestData = this.requestData?.RequestData || [];
    request.PageSize = this.pageNumber;
    request.PageRecordCount = 100;
    request.SortColumn = "itemDescription";

    try {
      const result: any = await this.repo.PostAPI(this.url, request).toPromise();

      let data = result && result.responseData ? result.responseData : null;
      if (Array.isArray(data) && data.length > 0) {
        data = data[0];
      }

      if (data && data.documentLines) {
        // Map the root docNum into each line so it can be displayed in the grid
        const newLines = data.documentLines.map((line: any) => ({
          ...line,
          docNum: line.docNum || data.docNum
        }));

        if (newLines.length > 0) {
          const existingLineNums = new Set(this.local_data.map((l: any) => l.lineNum ?? l.LineNum));
          const uniqueNewLines = newLines
            .filter((l: any) => !existingLineNums.has(l.lineNum ?? l.LineNum))
            .map((i: any) => ({ ...i, selected: false }));

          if (uniqueNewLines.length > 0) {
            this.local_data = [
              ...this.local_data,
              ...uniqueNewLines
            ];
          }
        }

        if (newLines.length < 100) {
          this.hasMoreLines = false;
        }
      } else {
        this.hasMoreLines = false;
      }
    } catch (error) {
      console.error('Error loading more document lines', error);
      this.pageNumber--;
    } finally {
      this.isLoadingMoreLines = false;
    }
  }

  override async PopulateListViewGeneric(aUrl: string, aRequestData: any): Promise<any[]> {
    // This override intercepts the generic filter and sort methods.
    // When a filter is clicked, GenericListView updates this.getRequestData
    // and calls this method. We apply it to our manual flow.

    // Ensure the permanent DocEntry filter is always re-added to the request.
    if (this.docEntryFilter && aRequestData && aRequestData.RequestData) {
      const hasDocEntry = aRequestData.RequestData.find((f: any) => f.Key === 'DocEntry');
      if (!hasDocEntry) {
        // Must put DocEntry at the very top as per other implementations
        aRequestData.RequestData.unshift(this.docEntryFilter);
      }
    }

    this.requestData = aRequestData;
    this.pageNumber = 0; // Will be incremented to 1 in loadMoreDocumentLines
    this.local_data = [];
    this.hasMoreLines = true;
    await this.loadMoreDocumentLines();
    return this.local_data;
  }
}
